import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { AppConfig } from "../../api/config/config";
import logo from "../../assets/images/icons/dome_care_logo2.svg";
import {
  GeneralImage,
  ShareLinkComponent
} from "../../components";
import { EndPoints } from "../../Constants/endpoints";
import { useGetData } from "../../hooks";
import { GetArticles } from "../../interface/GeneralResponse";
import { TitleWithArrow } from "../../Share";
import { formatDateTimeToShow } from "../../utils/utils";
import { ArticleDetailsLoader } from "./component";

function ArticleDetails() {
  const [isShareOpen, setIsShareOpen] = useState<boolean>(false);

  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data, isPending } = useGetData<GetArticles>(
    EndPoints.GetArticleById,
    {},
    id,
  );
  const articleData = data?.Data;

  return (
    <div className="box h-full overflow-y-auto">
      <TitleWithArrow title="domecare_articles" />
      {isPending ? (
        <ArticleDetailsLoader />
      ) : (
        <div className="flex gap-5 max-sm:flex-col">
          <GeneralImage
            src={articleData?.Images && articleData?.Images?.[0]}
            alt={articleData?.Title}
            className="rounded-xl !object-cover max-sm:h-72 max-sm:!w-[100vw] sm:!max-w-[50vw] md:!max-w-[30vw]"
          />
          <div className="flex w-full flex-col gap-4">
            <div className="flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center gap-2 text-sm">
                <img
                  src={logo}
                  alt="dome-care"
                  className="h-8 w-8 rounded-full"
                />
                <p className="font-bold">{t("app_name")}</p>
              </div>
              <p>
                {articleData?.Date
                  ? formatDateTimeToShow(articleData?.Date)
                  : ""}
              </p>
            </div>
            <h2 className="text-lg font-bold">{articleData?.Title}</h2>
            <p className="text-sm leading-7">{articleData?.Description}</p>
          </div>
        </div>
      )}

      <ShareLinkComponent
        shareLink={`${AppConfig.WEB_APP_URL}/articles/${articleData?.Title?.replaceAll(" ", "-")}/${articleData?.Id}`}
        open={isShareOpen}
        onClose={() => {
          setIsShareOpen(false);
        }}
      />
    </div>
  );
}

export default ArticleDetails;
